var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTxtBullets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.79 79.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VHIuaX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99,6.92h-36c-12.07,0-24.14,0-36.21,0a5.41,5.41,0,0,0-3.39,1c-1.9,1.72-2.13,4-1.26,6.43s2.5,3.05,4.87,3q36-.06,71.91,0c3.33,0,5.2-1.93,5.22-5.28S102.41,6.93,99,6.92Z",
    transform: "translate(-0.5 -6.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.86,41.46c-3.26,0-5.13,2-5.08,5.41s1.79,5.08,5,5.08H99c3.41,0,5.22-1.81,5.22-5.17s-1.88-5.32-5.19-5.32Z",
    transform: "translate(-0.5 -6.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,76.29h-36c-12,0-24,0-36,0-2.29,0-3.81.75-4.6,3-1.48,4.12.71,7.38,5.06,7.38H78c7.08,0,14.16,0,21.24,0,1.78,0,3.26-.34,4.21-2.05C105.69,80.49,103.36,76.29,98.74,76.29Z",
    transform: "translate(-0.5 -6.85)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.9 10.49 10.9 0 0 0 0 10.51 10.9 10.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.01 34.8 0.11 34.8 0.11 45.3 11.01 45.29 11.01 34.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.01 69.3 0.11 69.3 0.11 79.8 11.01 79.79 11.01 69.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTxtBullets);
export default __webpack_public_path__ + "static/media/icon_txt_bullets.84c571efa4600a00637876c44d080173.svg";
export { ForwardRef as ReactComponent };